import React from 'react';
import Banner from '../components/Banner';
import Clients from '../components/Clients';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import WhyChooseUs from '../components/WhyChooseUs';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import Faq from '../components/Faq';
import CallToAction from '../components/CallToAction';

const HomePage = () => {
  return (
    <>
      <Banner />
      <Clients />
      <Features />
      <HowItWorks />
      <WhyChooseUs />
      <Pricing />
      <Testimonials />
      <Faq />
      <CallToAction />
    </>
  );
};

export default HomePage;